export default __webpack_public_path__ + "static/media/26.3441a89c.jpg";